import { useState, useCallback } from 'react';
import { Post } from '../../../../lib/supabase';

interface PostShareBarProps {
  post: Post;
  plainText: string;
}

export function PostShareBar({ post, plainText }: PostShareBarProps) {
  const [copied, setCopied] = useState(false);
  const [urlCopied, setUrlCopied] = useState(false);

  const handleCopyText = useCallback(async () => {
    try {
      await navigator.clipboard.writeText(plainText);
    } catch {
      const ta = document.createElement('textarea');
      ta.value = plainText;
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      document.execCommand('copy');
      document.body.removeChild(ta);
    }
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  }, [plainText]);

  const handleCopyUrl = useCallback(async () => {
    const url = window.location.href;
    try {
      await navigator.clipboard.writeText(url);
    } catch {
      const ta = document.createElement('textarea');
      ta.value = url;
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      document.execCommand('copy');
      document.body.removeChild(ta);
    }
    setUrlCopied(true);
    setTimeout(() => setUrlCopied(false), 2000);
  }, []);

  return (
    <div className="flex flex-wrap items-center gap-2 py-5 border-t border-b border-[#EDE7DF] my-8">
      <span
        className="text-xs text-[#9A8E84] mr-1"
        style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
      >
        シェア:
      </span>

      {/* Copy URL */}
      <button
        onClick={handleCopyUrl}
        className="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs text-[#7A6E62] border border-[#E8E0D5] rounded-md hover:border-[#C8BFB5] hover:text-[#2C2416] transition-colors cursor-pointer whitespace-nowrap"
        style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
      >
        <i className={urlCopied ? 'ri-check-line text-[#5B7B6F]' : 'ri-links-line'}></i>
        {urlCopied ? 'コピーしました' : 'URLをコピー'}
      </button>

      {/* X share */}
      <a
        href={`https://x.com/intent/tweet?url=${encodeURIComponent(typeof window !== 'undefined' ? window.location.href : '')}&text=${encodeURIComponent(post.title)}`}
        target="_blank"
        rel="nofollow noopener noreferrer"
        className="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs text-[#7A6E62] border border-[#E8E0D5] rounded-md hover:border-[#C8BFB5] hover:text-[#2C2416] transition-colors cursor-pointer whitespace-nowrap"
        style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
      >
        <i className="ri-twitter-x-line"></i>
        Xでシェア
      </a>

      {/* AI copy */}
      <button
        onClick={handleCopyText}
        className="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs text-[#7A6E62] border border-[#E8E0D5] rounded-md hover:border-[#C8BFB5] hover:text-[#2C2416] transition-colors cursor-pointer whitespace-nowrap"
        style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
      >
        <i className={copied ? 'ri-check-line text-[#5B7B6F]' : 'ri-file-copy-line'}></i>
        {copied ? 'コピーしました' : 'AI用にコピー'}
      </button>
    </div>
  );
}
